import React from "react"
import { AddEditStatusForm } from "../../components/forms/AddEditStatusForm"

export const OrganizationAddEditStatuses = () => {
	return (
		<AddEditStatusForm/>	
	)
}
